<!-- Admin-only page: text here is deliberately left untranslated (out of scope per #4317). -->
<cs-header>
  <cs-header-title>User Subscription</cs-header-title>
</cs-header>

<cs-content [loading]="loading">
  <cs-card-list>
    <cs-card>
      <cs-card-title>MH Physique Info</cs-card-title>
      <cs-card-content>
        <cs-textarea [(value)]="couchInfoText" [readonly]="true" [autoadjustheight]="true"></cs-textarea>
        <div class="button-row">
          <cs-button secondary small
            [label]="'Change Email' | untranslated" (click)="handleChangeEmailButtonClick()"></cs-button>
        </div>
      </cs-card-content>
    </cs-card>
    <cs-card>
      <cs-card-title>Current Subscription State</cs-card-title>
      <cs-card-content>
        <cs-textarea [(value)]="currentStateText" [readonly]="true" [autoadjustheight]="true"></cs-textarea>
      </cs-card-content>
    </cs-card>
    <cs-card>
      <cs-card-title>Other Accounts For This Person</cs-card-title>
      <cs-card-content>
        <cs-textarea [(value)]="relatedAccountsText" [readonly]="true" [autoadjustheight]="true"></cs-textarea>
      </cs-card-content>
    </cs-card>
    <cs-card>
      <cs-card-title>Payments and Refunds</cs-card-title>
      <cs-card-content>
        <cs-textarea [(value)]="paymentHistoryText" [readonly]="true" [autoadjustheight]="true"></cs-textarea>
      </cs-card-content>
    </cs-card>
    <cs-card>
      <cs-card-title>Subscription Sync Status</cs-card-title>
      <cs-card-content>
        <cs-textarea [(value)]="syncedText" [readonly]="true" [autoadjustheight]="true"></cs-textarea>
        <div class="button-row">
          @if (canGrantFreeDays) {
            <cs-button secondary small
            [label]="'Grant Free Days' | untranslated" (click)="handleGrantFreeDaysButtonClick()"></cs-button>
          }
          @if (canCancelSubscription) {
            <cs-button secondary small
            [label]="'Cancel Subscription (End of Period)' | untranslated" (click)="handleCancelSubscriptionButtonClick()"></cs-button>
          }
          @if (canResumeSubscription) {
            <cs-button secondary small
            [label]="'Resume Subscription' | untranslated" (click)="handleResumeSubscriptionButtonClick()"></cs-button>
          }
          @if (canSwitchPlan) {
            <cs-button secondary small
            [label]="'Switch Plan (Monthly / Yearly)' | untranslated" (click)="handleSwitchPlanButtonClick()"></cs-button>
          }
          @if (canGrantLegacyPrice) {
            <cs-button secondary small
            [label]="'Grant Old PayPro Price' | untranslated" (click)="handleGrantLegacyPriceButtonClick()"></cs-button>
          }
          @if (canResyncSubscription) {
            <cs-button secondary small
            [label]="'Re-sync from Provider' | untranslated" (click)="handleSyncSubscriptionButtonClick()"></cs-button>
          }
        </div>
        <!-- Why the missing buttons are missing (#4362) — see `unavailableActions`. -->
        @if (unavailableActions.length > 0) {
          <div class="unavailable-actions">
            <div class="unavailable-actions-title">Not available for this customer:</div>
            @for (unavailable of unavailableActions; track unavailable.action) {
              <div class="unavailable-action">
                <span class="unavailable-action-name">{{ unavailable.action }}</span>
                <span class="unavailable-action-reason">{{ unavailable.reason }}</span>
              </div>
            }
          </div>
        }
      </cs-card-content>
    </cs-card>
    <cs-card>
      <cs-card-title>PayPro Global Info</cs-card-title>
      <cs-card-content>
        <cs-textarea [(value)]="payProInfoText" [readonly]="true" [autoadjustheight]="true"></cs-textarea>
      </cs-card-content>
    </cs-card>
  </cs-card-list>
</cs-content>